
import { defineComponent, onMounted, ref } from "vue";
import BxRegister from "@/components/auths/Register20230223.vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import PopupLoader from "@/components/modals/popups/PopupLoader.vue";
import { useRouter, useRoute } from "vue-router";

export default defineComponent({
  name: "signup-page",
  components: {
    BxRegister,
    PopupLoader,
  },
  emits: ["register:Complete"],
  setup() {
    const router = useRouter();
    const route = useRoute();
    const sponsorId = ref("");
    const seoId = ref("");
    const registerComplete = () => {
      router.push({ name: "sign-in" });
    };
    onMounted(() => {
      setCurrentPageTitle("สมัครสมาชิก");
      //registerComplete();
      if (route.name === "seo-link") {
        seoId.value = route.params.id as string; // store.getters.seoId;
      } else {
        sponsorId.value = route.params.id as string; // store.getters.sponsorId;
      }
    });
    return {
      registerComplete,
      sponsorId,
      seoId,
    };
  },
});
